module.exports = __webpack_public_path__ + "img/spain-other-heart-diseases-female.11d069cf.png";